import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { investigatePack } from 'services/scratcherService';
import type { PackInvestigationResponse } from '../../types';

export const usePackInvestigation = () => {
  const queryClient = useQueryClient();

  const fetchPackInvestigation = useCallback(
    async (storeId: string, gameId: string, packId: string): Promise<PackInvestigationResponse> => {
      const response = await investigatePack(storeId, gameId, packId);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Pack investigation failed');
      }
      if (response.data.correction?.corrected) {
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: ['lottery-packs', storeId] }),
          queryClient.invalidateQueries({ queryKey: ['current-inventory-status', storeId] }),
          queryClient.invalidateQueries({ queryKey: ['game-pack-report', storeId] }),
          queryClient.invalidateQueries({ queryKey: ['pack-lifecycle', storeId, gameId, packId] }),
        ]);
      }
      return response.data;
    },
    [queryClient]
  );

  return { fetchPackInvestigation };
};
